<template lang='pug'>
div
    div.fullwidth(v-if="$route.params.lang == 'en'")

        h1.title Contact us:
        h2
        .column-container
            div.column
                span.bold Sales:
                Maillink(to='sales@bss-hs.de', text='sales@bss-hs.de', size=25, strokeWidth=3)
            div.column
                span.bold Support:
                Maillink(to='support@bss-hs.de', text='support@bss-hs.de', size=25, strokeWidth=3)
            div.column
                span.bold General inquiries:
                Maillink(to='mail@bss-hs.de', text='mail@bss-hs.de', size=25, strokeWidth=3)
        div.margin-top-20
            .column-container
                div.column
                    span.bold Telephone:
                    PhoneLink(to='+49 (0) 711 217 2117 0', size=25)
                div.column
                    span.bold LinkedIn:
                    LinkedInLink(to='https://de.linkedin.com/company/bss-hochspannungstechnik', size=35, stroke-width=1, text='BSS Hochspannungstechnik GmbH')
                div.column

            
    
        h1.title.margin-top-50 Locations:
        h2
        .column-container
            div.column.align-top
                span.bold Billing Address:
                p BSS Hochspannungstechnik GmbH #[br] Umberto-Nobile-Str. 15 #[br] 71063 Sindelfingen #[br] Germany
                Maillink(to='invoice@bss-hs.de', text='invoice@bss-hs.de', size=25, strokeWidth=3)

            div.column.align-top
                span.bold Office Address:
                div BSS Hochspannungstechnik GmbH #[br] Innovaphone Coworking #[br] Umberto-Nobile-Str. 15 #[br] 71063 Sindelfingen #[br] Germany
                ExternalLink(to='https://maps.app.goo.gl/ziiUQh32TitL8JPo6', size="20", text='Google Maps')

            div.column.align-top
                span.bold Delivery Address:
                div BSS Hochspannungstechnik GmbH #[br] Schelmenwasenstr. 45 #[br] 70567 Stuttgart #[br] Germany
                ExternalLink(to='https://maps.app.goo.gl/wxNrrJyk3giJQRun8', size=20, text='Google Maps')

        div.margin-top-50
            h1.title Send us a message:
            h2
            ContactForm(lang="en")


    div.fullwidth(v-if="$route.params.lang == 'de'")
        
        h1.title So erreichen Sie uns:
        h2
        .column-container
            div.column
                span.bold Verkauf:
                Maillink(to='sales@bss-hs.de', text='sales@bss-hs.de', size=25, strokeWidth=3)
            div.column
                span.bold Support:
                Maillink(to='support@bss-hs.de', text='support@bss-hs.de', size=25, strokeWidth=3)
            div.column
                span.bold Allgemein:
                Maillink(to='mail@bss-hs.de', text='mail@bss-hs.de', size=25, strokeWidth=3)
        div.margin-top-20
            .column-container
                div.column
                    span.bold Telefon:
                    PhoneLink(to='+49 (0) 711 217 2117 0', size=25)
                div.column
                    span.bold LinkedIn:
                    LinkedInLink(to='https://de.linkedin.com/company/bss-hochspannungstechnik', size=35, stroke-width=1, text='BSS Hochspannungstechnik GmbH')
                div.column

        h1.title.margin-top-50 Adressen:
        h2
        .column-container
            div.column.align-top
                span.bold Rechnungsadresse:
                p BSS Hochspannungstechnik GmbH #[br] Umberto-Nobile-Str. 15 #[br] 71063 Sindelfingen #[br] Deutschland
                Maillink(to='rechnung@bss-hs.de', text='rechnung@bss-hs.de', size=25, strokeWidth=3)

            div.column.align-top
                span.bold Büroadresse:
                div BSS Hochspannungstechnik GmbH #[br] Innovaphone Coworking #[br] Umberto-Nobile-Str. 15 #[br] 71063 Sindelfingen #[br] Deutschland
                ExternalLink(to='https://maps.app.goo.gl/ziiUQh32TitL8JPo6', size="20", text='Google Maps')
                
            div.column.align-top
                span.bold Lieferadresse:
                div BSS Hochspannungstechnik GmbH #[br] Schelmenwasenstr. 45 #[br] 70567 Stuttgart #[br] Deutschland
                ExternalLink(to='https://maps.app.goo.gl/wxNrrJyk3giJQRun8', size="20", text='Google Maps')

        div.margin-top-50
            h1.title Schreiben Sie uns eine Nachricht:
            h2
            ContactForm(lang="de")
</template>

<script>
import ContactForm from "@/components/ContactForm.vue";

export default {
    components: {
        ContactForm,
    },
    meta: {
        de: {
            title: "BSS - Kontakt",
            description:
                "Ihr Experte für Teilentladungs-Monitoring - Treten Sie jetzt über E-Mail, Telefon oder postalisch mit BSS Hochspannungstechnik GmbH in Kontakt",
        },
        en: {
            title: "BSS - Contact",
            description:
                "Your expert for Partial-Discharge-Monitoring - Contact BSS Hochspannungstechnik GmbH via e-mail, phone number or postal address now",
        },
    },
};
</script>

<style lang='sass' scoped>
</style>